import {Alpine} from "alpinejs";
import {$http} from "../../utils";

Alpine.store('favourite', {
    products: [],
    addLog: [],
    removeLog: [],

    init() {
        function getFavourites() {
            this.products = JSON.parse(localStorage.getItem('_favourite')) || [];
            this.addLog = JSON.parse(localStorage.getItem('_favouriteAddLog')) || [];
            this.removeLog = JSON.parse(localStorage.getItem('_favouriteRemoveLog')) || [];
            this.sync();
        }

        window.addEventListener('window-reload', () => getFavourites())
        getFavourites.call(this);
    },

    addProduct(id) {
        if (this.products.find(item => item.id === id)) {
            return;
        }
        this.removeLog = this.removeLog.filter(item => item.id !== id);
        this.products.push({id});
        this.addLog.push({id});
        Alpine.store('products').fetchProducts();
        this.save();
    },

    removeProduct(id) {
        this.products = this.products.filter(item => item.id !== id);
        this.addLog = this.addLog.filter(item => item.id !== id);
        this.removeLog.push({id});
        Alpine.store('products').fetchProducts();
        this.save();
    },

    toggleProduct(id) {
        if (this.products.find(item => item.id === id)) {
            this.removeProduct(id);
            return;
        }
        this.addProduct(id);
        Alpine.store('products').fetchProducts();
    },

    checkProduct(id) {
        return !!this.products.find(item => item.id === id);
    },

    save() {
        localStorage.setItem('_favourite', JSON.stringify(this.products));
        localStorage.setItem('_favouriteAddLog', JSON.stringify(this.addLog));
        localStorage.setItem('_favouriteRemoveLog', JSON.stringify(this.removeLog));
    },

    sync() {
        if (!window.auth) return;
        const addLog = this.addLog.map(item => item.id);
        const removeLog = this.removeLog.map(item => item.id);

        $http.post("/api/v1/wishlist/sync", {
            add: addLog,
            remove: removeLog,
        }).then((response) => {
            this.products = [];
            response.data.data.forEach(item => {
                this.products.push({id: item});
            })
            this.addLog = [];
            this.removeLog = [];
            this.save();
        })
    },

    clear() {
        if (window.auth) {
            $http.post("/api/v1/wishlist/clear")
                .then(
                    () => {
                        this.products = [];
                        this.addLog = [];
                        this.removeLog = [];
                        this.save();
                    }
                )
                .catch(() => {})
        }
        else {
            this.products = [];
            this.addLog = [];
            this.removeLog = [];
            this.save();
        }
    },

    getProducts() {
        return this.products.map(item => item.id);
    },

    getProductsCount() {
        return this.products.length;
    },

    addAllToBasket() {
        this.products.forEach(item => {
            Alpine.store('basket').addEmpty(item.id)
        })
        Alpine.store('modal').open('basket');
    }
});

window.favourite = Alpine.store('favourite');
